import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DocumentEmailReadReportParams, DocumentEmailReads, DocumentEmailReadsParams } from "src/app/domain/models/DocumentEmailRead";
import { PageResult } from "src/app/domain/models/PageResult";

@Injectable({providedIn: 'root'})
export abstract class DocumentEmailReadGateway {
  abstract getDocumentEmailReads(request: DocumentEmailReadsParams): Observable<PageResult<DocumentEmailReads>>
  abstract getDocumentToAssign(request: DocumentEmailReadsParams): Observable<PageResult<DocumentEmailReads>>
  abstract getEmailDocument(documentEmailReadId: string): Observable<any>
  abstract deleteDocument(documentEmailReadId: string): Observable<any>
  abstract downloadReport(request: DocumentEmailReadReportParams): Observable<any>
}
